import React from "react";
import { Button } from "@material-ui/core";
import PropTypes from "prop-types";

import TierForm from "./tier-form";

const TiersInformations = props => (
  <div>
    <h4>Tiers' Informations</h4>

    {[...Array(props.values.tierceAutorisesDto.length)].map((item, index) => (
      <TierForm key={index} {...props} index={index} />
    ))}
    <Button color="primary" onClick={props.handleAddTier}>
      Ajouter un tier
    </Button>
  </div>
);

TiersInformations.propTypes = {
  values: PropTypes.object,
  handleAddTier: PropTypes.func
};

export default TiersInformations;
